import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { FundsDropdown, LedgerRender, SnapShotAssetPair, SnapShotAssetPairCommodity, SnapShotAssetPairMTF, } from "./Constants";
import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import ReceivedPayment from "@frameworks/web/components/Reports/LedgerReports/ReceivedPayments";
import di from "@frameworks/web/components/Reports/LedgerReports/di/servicelocator";
import { getDateInFormat } from "@domains/utils/reportDates";
import { useSelector } from "react-redux";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { LEDGER_COMM_ENTITY, } from "@domains/entities/interfaces/Reports/LedgerReport/ILedgerReport";
const LedgerSnapShot = (props) => {
    const device = DeviceContext();
    const [extenstionDrawer, setExtenstionDrawer] = useState(false);
    const { reducersData: snapShot, commonData: snapShotCommonData } = useSelector((state) => state.LedgerReport.snapShot);
    const snapTitleRowClickAllowed = (x, assetVal) => {
        if (x && assetVal)
            return x.allowOnClick && assetVal !== 0;
    };
    const setToFundDetails = (x, assetVal) => {
        if (snapTitleRowClickAllowed(x, assetVal)) {
            let payload = {
                fromDate: getDateInFormat(props.startDate, "YYYY-MM-DD"),
                toDate: getDateInFormat(props.endDate, "YYYY-MM-DD"),
                segment: null,
                currentValue: "1",
                flag: x.shotExtention,
                accountId: props.accCode,
            };
            di.ledger.snapShotExtentionDetails(payload);
            props.setSnapExtention(x.shotExtention);
            if (device.isDesktop)
                props.setLedgerReport(LedgerRender.FUNDSDETAILS);
            else {
                props.setSnapExtention(x.shotExtention);
                setExtenstionDrawer(true);
            }
        }
    };
    const snapShotRows = (SnapShotAssetPair) => {
        return SnapShotAssetPair.map((x, idx) => {
            var _a, _b;
            let assetVal = (_b = (_a = snapShot.snapShot) === null || _a === void 0 ? void 0 : _a.find((y) => y.asset === x.valFromAPI)) === null || _b === void 0 ? void 0 : _b.assetVal;
            return (React.createElement("tr", { className: `${x.rowClass}`, key: idx },
                React.createElement("td", { className: `${(device === null || device === void 0 ? void 0 : device.isDesktop) ? x.LshiftedRow : x.LshiftedRowMob} ${snapTitleRowClickAllowed(x, assetVal)
                        ? "txt-midnight-blue txt-underline hand_cursor"
                        : "txt_blackOne1"}` },
                    React.createElement("span", { className: "txt_blackOne1", onClick: (e) => setToFundDetails(x, assetVal) }, x.title)),
                React.createElement("td", { className: `${x === null || x === void 0 ? void 0 : x.RshiftedRow} ${(device === null || device === void 0 ? void 0 : device.isDesktop)
                        ? "RobotoM_16_500 pdl-22 "
                        : " RobotoM_14_500 text-right "}
            ` },
                    React.createElement("span", { className: "txt_blackOne1" },
                        React.createElement(ReportValue, { val: assetVal ? assetVal : 0, stream: assetVal ? true : false, onlyval: assetVal ? false : true, showZero: true, issuffixhide: true })))));
        });
    };
    const EQCOMAccHandler = () => {
        if ((props.accType === ILoginAccountTypes.COMEQ &&
            props.COMEQTOGGLE === ILoginAccountTypes.EQ) ||
            props.accType === ILoginAccountTypes.EQ)
            return snapShotRows(SnapShotAssetPair);
        else if ((props.accType === ILoginAccountTypes.COMEQ &&
            props.COMEQTOGGLE === ILoginAccountTypes.CO) ||
            props.accType === ILoginAccountTypes.CO)
            return snapShotRows(SnapShotAssetPairCommodity);
    };
    const snapShotDisplay = () => {
        var _a;
        if (snapShotCommonData.loader)
            return React.createElement(Common_Shimmer, null);
        if ((_a = snapShotCommonData.errorData) === null || _a === void 0 ? void 0 : _a.isOpen)
            return (React.createElement(ErrorNotification, { error: snapShotCommonData.errorData.error, isOpen: snapShotCommonData.errorData.isOpen, displayType: ErrorDisplayType.INSECTION }));
        return (React.createElement(React.Fragment, null, props.MTFToggle ? (React.createElement("table", { className: "table ledger-table-border mt-10 mb-0" },
            React.createElement("tbody", null, props.COMEQTOGGLE === ILoginAccountTypes.EQ &&
                snapShotRows(SnapShotAssetPairMTF)))) : (React.createElement("div", null,
            React.createElement("table", { className: "table ledger-table-border mt-10 mb-0" },
                React.createElement("tbody", null, EQCOMAccHandler()))))));
    };
    const snapShotData = () => {
        let commPayload = null, EqPayload = null;
        EqPayload = {
            fromDate: getDateInFormat(props.startDate, "YYYY-MM-DD"),
            toDate: getDateInFormat(props.endDate, "YYYY-MM-DD"),
            isMtf: props.MTFToggle,
            isPdf: true,
            duration: null,
            ACCTYPE: ILoginAccountTypes.EQ,
            accountId: props.accCode,
        };
        commPayload = {
            fromDate: getDateInFormat(props.startDate, "YYYY-MM-DD"),
            toDate: getDateInFormat(props.endDate, "YYYY-MM-DD"),
            isPdf: true,
            duration: null,
            ACCTYPE: ILoginAccountTypes.CO,
            entity: LEDGER_COMM_ENTITY.EBL,
            accountId: props.accCode,
        };
        if ((props.COMEQTOGGLE === ILoginAccountTypes.EQ &&
            props.accType === ILoginAccountTypes.COMEQ) ||
            props.accType === ILoginAccountTypes.EQ)
            di.ledger.getLedgerSnapShot(EqPayload);
        if ((props.COMEQTOGGLE === ILoginAccountTypes.CO &&
            props.accType === ILoginAccountTypes.COMEQ) ||
            props.accType === ILoginAccountTypes.CO)
            di.ledger.getLedgerSnapShot(commPayload);
    };
    useEffect(() => {
        if (props.accCode)
            snapShotData();
    }, [
        props.MTFToggle,
        props.startDate,
        props.endDate,
        props.COMEQTOGGLE,
        props.accType,
        props.accCode,
    ]);
    return (React.createElement(React.Fragment, null,
        snapShotDisplay(),
        React.createElement(GenericDrawer, { show: extenstionDrawer, setShow: setExtenstionDrawer, parentClass: "z-index-high", headerComp: React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1 receive-payment-head" }, FundsDropdown.find((x) => x.value === props.snapExtension).title), bodyComp: React.createElement(ReceivedPayment, null) })));
};
export default LedgerSnapShot;
